<template>
    <Head title="User Role Edit" />
    <bernstein-layout> 
        <div class ="flex justify-around space-x-12 min-h-screen"  v-if="user">
             <div class="py-4 px-6 flex flex-col w-1/2">
                <div class="max-h-16 flex py-2"> <span class="w-1/2">  Name: </span> <span class="w-1/2 max-h-8">  {{user.name}} </span></div>
                <div class="max-h-16 flex py-2"> <span class="w-1/2">  Email: </span> <span class="w-1/2 max-h-8">  {{user.email}} </span></div>
                <div class="flex py-2"><span class="w-1/2">  aktuelle Rolle: </span>  
                   <ul class="w-1/2"> 
                       <li class="py-2 list-disc " 
                        v-for="(rle, rIndx) in role " :key ="rIndx"> 
                          {{rle}}  
                        </li> 
                </ul>
                                
             </div>
             </div>
              <!-- Update role form  -->
             <div class="py-2 px-6 mb-2 ">
                  <form @submit.prevent="submit">
                                     <div id="v-model-multiple-checkboxes" 
                                      v-for="(role, roleIndx) in roles" :key="roleIndx" 
                                     class="flex p-2 "
                                     >
                                        <div  v-if="checkedRoles[roleIndx]"    
                                        class="flex  justify-center items-center text-center"> 
                                          <input  class="p-2 text-center "   
                                           type="checkbox"  
                                           :id="role.name"  
                                           :name ="role.name"  
                                           :value ="role.name" v-model="form.actualRoles"  checked>                             
                                            <label class="px-2 py-2 text-center text-gray-900"  :for="role" >
                                                {{role.name}}</label> 
                                        </div>
                                          <!-- without checked  -->
                                          <div  v-else  class="flex  justify-center items-center text-center">  
                                            <input class="p-2 text-center"
                                            type="checkbox"  
                                            :id ="role.name"
                                            :name ="role.name"                                                                              
                                            :value="role.name"  
                                            v-model="form.actualRoles"
                                            />
                                            <label class="px-2 py-2 text-center ext-gray-900"  :for ="role" >{{role.name}}</label>
                                        </div>
                                        
                                    </div>
                                   
                                     <button type="submit" 
                                     class="mt-2 px-10 py-4 text-sm text-white bg-blue-500 rounded m-auto ">
                                        Speichern
                                    </button>
                                  </form>
             </div>
             <!-- here starts  -->


             <!-- here ends  -->
        </div>
        <div v-else class="min-h-screen mx-auto">
              User is not selected. 
        </div> 
    </bernstein-layout>
</template>
<script>
    import BernsteinLayout from '@/Layouts/BernsteinLayout.vue'
    import { Head  } from '@inertiajs/inertia-vue3'
    import { reactive } from '@vue/reactivity'
    //  import { reactive } from 'vue'
    import { Inertia } from '@inertiajs/inertia'


export default {
    components:{
        BernsteinLayout,
        Head 
    },
        
   props:{
        'user':  Array,
        'role':  Array, 
         'roles':  Array,
         'checkedRoles': Array
   },
     setup(){
       const form  =reactive({
           actualRoles : [],
           user: []
       })
        function submit() {
            
        console.log(this.actualRoles)
            Inertia.post('/user/role/save', form)
        }
        // watchEffect(() => console.log("Value: " + form.actualRoles));
        return { form, submit }

   },
   created(){
       this.form.actualRoles =this.role
       this.form.user =this.user
   } 
  
}
</script>
